// Messages
const ABORT_MESSAGE_DISPATCH = 'Aborting message dispatching.';
const INVALID_MESSAGE_SCHEMA = `Message params not matching schema, check your registered bridge. ${ABORT_MESSAGE_DISPATCH}`;

// Default validation
export const validateMessageSchema = (schema, message) => {
  const schemaKeys = Object.keys(schema);
  const messageKeys = Object.keys(message);

  // Check if some type not match
  const messageTypesAreInvalid = schemaKeys.some(
    schemaKey => typeof message[schemaKey] !== schema[schemaKey]
  );

  // Check if message keys and schema keys lengths are equal
  const schemaLength = schemaKeys.length;
  const messageLength = messageKeys.length;
  const keyLengthsAreDifferent = schemaLength !== messageLength;

  // Check if keys names are equal
  const keysAreDifferent = schemaKeys.some(
    schemaKey => !messageKeys.includes(schemaKey)
  );

  if (messageTypesAreInvalid || keyLengthsAreDifferent || keysAreDifferent) {
    console.warn(INVALID_MESSAGE_SCHEMA);
    return false;
  }

  return true;
};
